import OktaAuth from "@okta/okta-auth-js";
import apiConfig from "./apiConfig";
import { InteractionRequiredAuthError, IPublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { IdToken } from "@auth0/auth0-spa-js";

async function getFreshIdToken(instance: IPublicClientApplication, account: AccountInfo): Promise<string> {
  const request = {
    scopes: ["openid", "profile", "email"],
    account,
  };

  try {
    const result = await instance.acquireTokenSilent(request);
    return result.idToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const result = await instance.loginPopup(request);
      return result.idToken;
    }
    throw error;
  }
}

const api = {
  headers(authToken: string, identityProvider: string) {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      "x-identity-provider": identityProvider,
    };
  },
  async fetch(url: string, authToken: string, identityProvider = "Entra", method = "GET", body: any = null) {
    if (identityProvider == "Entra") {
      let instance = window["authInstance"] as IPublicClientApplication;
      const account = instance.getActiveAccount();
      authToken = await getFreshIdToken(instance, account);
    } else if (identityProvider == "Okta") {
      let oktaInstance = window["oktaInstance"] as OktaAuth;
      const idTokenObj = (await oktaInstance.tokenManager.get("idToken")) as any as IdToken;
      authToken = idTokenObj?.idToken;
    }

    return await fetch(apiConfig.baseUrl + "/" + url, {
      method: method,
      headers: this.headers(authToken, identityProvider),
      body: body != null ? JSON.stringify(body) : null,
    });
  },
  async post(url: string, body: any, authToken: string, identityProvider = "Entra") {
    return await this.fetch(url, authToken, identityProvider, "POST", body);
  },
  async delete(url: string, authToken: string, identityProvider = "Entra") {
    return await this.fetch(url, authToken, identityProvider, "DELETE");
  },
};

export default api;
